/** @jsx jsx */
import { jsx } from 'theme-ui'
import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  TumblrShareButton,
  TwitterShareButton,
  FacebookIcon,
  EmailIcon,
  PinterestIcon,
  TumblrIcon,
  TwitterIcon
} from 'react-share'

export const SocialShare = ({ url, image = null }) => {
  return (
    <div>
      <FacebookShareButton url={url} sx={{ marginLeft: '2px' }}>
        <FacebookIcon size={32} sx={{ padding: '5px' }} />
      </FacebookShareButton>
      <TwitterShareButton url={url} sx={{ marginLeft: '2px' }}>
        <TwitterIcon size={32} sx={{ padding: '5px' }} />
      </TwitterShareButton>
      {image && (
        <PinterestShareButton url={url} media={image} sx={{ marginLeft: '2px' }}>
          <PinterestIcon size={32} sx={{ padding: '5px' }} />
        </PinterestShareButton>
      )}
      <TumblrShareButton url={url} sx={{ marginLeft: '2px' }}>
        <TumblrIcon size={32} sx={{ padding: '5px' }} />
      </TumblrShareButton>
      <EmailShareButton url={url} sx={{ marginLeft: '2px' }}>
        <EmailIcon size={32} sx={{ padding: '5px' }} />
      </EmailShareButton>
    </div>
  )
}
